module.exports = __webpack_public_path__ + "img/Tail_feathers_DiffuseColor.16eaf8a.png";